<template>
  <main
    :class="useRoute().meta?.fillHeight ? 'FillHeight' : ''"
  >
    <template v-if="useAuthStore().isLoggedIn">
      <div
        v-if="useRoute().meta?.lightBackground"
        class="layout-fixed-bg bg-light"
      />

      <ClientAppHeader
        v-if="!useUIStore().accessibility.fullscreen"
      />

      <slot />

      <ConfirmEmergencyDialog />
      <ClientInAppAlert />
      <OperatorCallingBox v-if="useOperatorCallingStore().number && useOperatorCallingStore().token" />
    </template>
    <div
      v-else
      v-loading="true"
      class="min-h-20"
    />
  </main>
</template>

<script setup>
// Refs
const i18n = useNuxtApp().$i18n;
const route = useRoute();
const localePath = useLocalePath();

// Computed
const requests = computed(() => useNuxtApp().$store.state.client.requests.requests);

// Watchers
watch(() => useAuthStore().user?.lang, () => {
  if (useAuthStore().user?.lang) {
    i18n.setLocale(useAuthStore().user?.lang);
  }
}, { immediate: true });

// Feature - redirect to ongoing request
watch(requests, () => {
  if (!route.name?.includes('requests-id-chat')) {
    const ongoingRequest = requests.value.find((request) => request.state_id === 2 || request.state_id === 3);
    if (ongoingRequest) {
      navigateTo(localePath(`/requests/${ongoingRequest.id}/chat`));
    }
  }
}, {
  deep: true,
  immediate: true,
});

onMounted(() => {
  if (!route.name?.includes('requests')) {
    useNuxtApp().$store.dispatch('client/requests/getRequests');
  }

  window.joinCall = () => {
    useOperatorCallingStore().number = '774915537';

    const token = prompt('Enter token');
    useOperatorCallingStore().token = token;

    const hash = prompt('Enter hash');
    useOperatorCallingStore().hash = hash;
  };
});
</script>

<style scoped>
main {
  &.FillHeight {
    padding-bottom: 0;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    /* iOS without dvh support (< 15.4) */
    @supports (-webkit-touch-callout: none) and (not (height: 100dvh)) {
      @media (min-height: 450px) {
        max-height: -webkit-fill-available;
      }
    }
  }
}

main.FillHeight :deep(.page) {
  padding-bottom: 0;
  min-height: 0; /* .page min-height is 100vh-based, taller than 100dvh */
}
</style>
